<div class="flex flex-col gap-5">
  <p-fileupload
    class="w-full"
    [files]="selectedFiles"
    [mode]="mode"
    customUpload="true"
    [accept]="accept"
    [showUploadButton]="showUploadButton"
    [disabled]="disabled"
    [multiple]="multiple"
    (onSelect)="onSelectInternal($event)"
    (onRemove)="onRemoveInternal($event)"
    (onClear)="resetSelectedFiles()"
    [chooseLabel]="chooseLabel | translate"
    [cancelLabel]="cancelLabel | translate"></p-fileupload>

  <ng-container *ngIf="files | async as fileList">
    <ng-container *ngIf="fileList.length > 0">
      <span class="text-sm">{{ existingLabel | translate }}</span>
      <sm-file-list
        class="w-full"
        [files]="files"
        [onFileRepresentationChange]="onFileRepresentationChange"
        [existingFileHeader]="existingFileHeader"
        [disabled]="disabled"
        [openFile]="openFile"
        [onFileDownLoad]="onFileDownLoad"
        [onAllRemoved]="onAllRemoved">
      </sm-file-list>
    </ng-container>
  </ng-container>
</div>
